import { postAction } from '@/apis/request'
import { CarItem } from '@/views/garage/type'

// /garage/add 新增我的车型
export function addMyCar(params) {
  return postAction('/cms/garage/add', params)
}

// /garage/delete 删除我的车型
export function deleteMyCar(params) {
  return postAction('/cms/garage/delete', params)
}

// /garage/favourite 设置偏好
export function setMyCarFavourite(params) {
  return postAction('/cms/garage/favourite', params)
}

// POST /garage/getSelect 获取筛选
export function getCarSelectOptions(params) {
  return postAction('/cms/garage/getSelect', params)
}

// POST /garage/list 查询车型列表
export function getCarListByFilter(params) {
  return postAction('/cms/garage/list', params)
}

// POST /garage/query 查询我的车型
export function getMyCarList(params): Promise<{
  data: CarItem[]
}> {
  return postAction('/cms/garage/queryMyGarage', params)
}
